import {Injectable} from "@angular/core";
import {Platform, AlertController, Events, App} from "ionic-angular";
import {DeviceService} from "./device.service";
import {ToastService} from "./toast.service";
import {TranslateService} from "@ngx-translate/core";
import {JobPage} from "../../pages/job/job.page";
import {environment} from "../config/environment";
import {OneSignal} from "@ionic-native/onesignal";

@Injectable()
export class PushService {

  constructor(private platform: Platform,
              private deviceService: DeviceService,
              private push: OneSignal,
              private toast: ToastService,
              private alertCtrl: AlertController,
              private translate: TranslateService,
              private events: Events,
              private app: App) {
  }

  init() {
    if (this.platform.is('cordova')) {
      this.push.startInit(environment.push.oneSignalAppId, environment.push.googleProjectId);

      this.push.inFocusDisplaying(this.push.OSInFocusDisplayOption.None);

      /*this.push.handleNotificationOpened()
        .subscribe((notification) => this.handleNotification(notification));*/

      this.push.handleNotificationReceived()
        .subscribe((notification) => this.handleNotification(notification));

      this.push.endInit();

      this.registerDeviceForUser();
    }

  }

  registerDeviceForUser() {
    this.platform.ready().then(() => {
      if(this.platform.is('cordova')){
        this.push.getIds()
          .then(result => {

            // Save token in our database
            this.deviceService.saveDevice(result.userId)
              .subscribe();
          });
      }
    });
  }

  private handleNotification(msg) {
    // Refresh jobs lists
    this.events.publish('JobsUpdated');

    // Show notifications
    if (msg.payload &&
      msg.payload.additionalData &&
      msg.payload.additionalData.event) {

      let event = msg.payload.additionalData.event;
      if (event === 'JobUpdated'
        || event === 'JobCancelled'
        || event === 'JobUpcoming') {
        return this.presentShowDetailsAlert(msg);
      }
    }
    return this.toast.show(msg.payload.title + ' ' + msg.payload.body);
  }

  private presentShowDetailsAlert(msg) {
    let confirm = this.alertCtrl.create({
      title: msg.payload.title,
      subTitle: msg.payload.body,
      buttons: [
        this.translate.instant('global.cancel'),
        {
          text: this.translate.instant('global.view'),
          handler: () => {
            confirm.dismiss()
              .then(() => this.app.getRootNav().push(JobPage, {id: msg.payload.additionalData.id}));
            return false;
          }
        }
      ]
    });
    return confirm.present();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/push.service.ts